import { t } from 'i18next'
import { useNavigate } from 'react-router'
import { StyledHeader } from 'styles/styledGlobal'

interface IPros {
  navigatePath: string
  label: string
}
const HeaderGoBack = (props: IPros) => {
  const { label } = props
  const navigate = useNavigate()
  return (
    <StyledHeader onClick={() => navigate(-1)}>
      <img src="/images/ic-arrow-left.svg" alt="" />
      {t(label)}
    </StyledHeader>
  )
}

export default HeaderGoBack
